import { reqCyQueryAdvert, reqCyWateringState } from 'changyo-public-api'
import cookie from 'js-cookie'

const token = cookie.get('login_token')

export default {
  name: 'BallBlock',
  props: {
    keyId: {
      type: String,
      required: true
    },
    channel: {
      type: String,
      default: 'Changyoyo_Life_Central'
    },
    spm: {
      type: String,
      default: ''
    },
    gio: {
      type: Object,
      default: () => ({})
    },
    cell: {
      type: String,
      default: '5'
    },
    newMsgCount: {
      type: Number,
      default: 0
    },
    tagDisabled: {
      type: Boolean,
      default: false
    },
    descDisabled: {
      type: Boolean,
      default: false
    },
    onDataLoaded: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      items: [],

      // 显示果园动图
      enableGardenGif: false
    }
  },
  mounted() {
    this.getData()

    if (token) {
      this.check()
    }
  },
  methods: {
    async getData() {
      const res = await reqCyQueryAdvert({
        featuredFirstCode: this.keyId,
        channel: this.channel
      }).catch(err => {
        console.log(err)
      })

      if (res && res.data) {
        const data = res.data.advertiseOnlines

        if (data && data.length > 0) {
          this.items = res.data.advertiseOnlines.map((item, index) => {
            item.gioData = JSON.stringify(Object.assign({}, this.gio, {
              pitCode: this.spm,
              ModuleCode: this.gio.ModuleCode + '_' + (index + 1),
              ModuleName: this.gio.ModuleName + '_' + (index + 1),
              pitPositionName: item.advertiseName
            }))

            return item
          })
          this.onDataLoaded(res.data.advertiseOnlines)
        }
      }
    },
    async check() {
      const res = await reqCyWateringState({
        appCode: this.channel
      }).catch(err => {
        console.log(err)
      })

      if (res && res.data) {
        this.enableGardenGif = res.data.show || false
      }
    },
    linkTo(url) {
      if (url.toString() !== '1') {
        location.href = url
      }
    },
    onItemClick(item) {
      if (item.jumpLink !== '1') {
        location.href = item.jumpLink
      }
    }
  }
}
